"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DataModel_1 = __importDefault(require("./DataModel"));
class Location extends DataModel_1.default {
    constructor(client, data) {
        super();
        this.client = client;
        this.shortStreet = data.short_street;
        this.shortState = data.short_state;
        this.shortCountry = data.short_country;
        this.shortCity = data.short_city;
        this.longStreet = data.long_street;
        this.longState = data.long_state;
        this.longCountry = data.long_country;
        this.longCity = data.long_city;
        this.location = data.location;
        this.cityId = data.city_id;
    }
    get data() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const _a = this, { client } = _a, rest = __rest(_a, ["client"]);
        return Object.assign({}, rest);
    }
}
exports.default = Location;
//# sourceMappingURL=Location.js.map